<!-- Cabecera -->
<div class="cabecera-govco d-md-none">
  <div class="barra-inferior-govco barra-inferior-desktop">
    <div class="barra-logos-govco">
      <!-- Buscador -->
      <div
        class="d-flex flex-column justify-content-center d-none d-md-block"
        style="width: 350px">
        <div class="govco-search-basic">
          <div class="container-govco d-flex" id="containter-default">
            <input
              type="text"
              class="input-search-basic-govco"
              id="input-basic"
              placeholder="Buscar por componente"
              aria-label="buscar por componente" />
            <button
              class="btn-clean-basic-govco me-2"
              type="button"
              id="btn-clean-basic"
              aria-label="Limpiar">
              <span class="govco-svg govco-times"></span>
            </button>
            <div class="line-basic-govco"></div>
            <button class="btn-search-basic-govco" type="button"
              aria-label="Buscar">
              <span class="govco-svg govco-search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>
      <!-- Buscador -->
      <a
        class="logo__justicia"
        target="_blank"
        rel="noopener"
        aria-label="MINTIC">
      </a>
    </div>
    <!-- Menu responsive -->
    <button
      class="navbar-toggler btn-menu-govco"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="icon-menu-govco"></span>
    </button>
    <!-- Menu responsive -->
  </div>
  <div class="border-bottom-govco"></div>
</div>
<!-- Cabecera -->

<!-- Menu -->
<nav
  class="navbar navbar-expand-md menu-govco"
  aria-label="Ejemplo Menú de navegación"
  role="navigation">
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
          <button
            type="button"
            class="nav-link dir-menu-govco"
            (click)="navegar('cms', true); closeMenu()"
            [attr.aria-label]="'navbar.inicio' | translate">
            <span>{{ 'navbar.inicio' | translate }}</span>
          </button>
        </li>
        <li class="nav-item">
          <button
            type="button"
            class="nav-link dir-menu-govco"
            (click)="navegar('login', true); closeMenu()"
            [attr.aria-label]="'navbar.portal' | translate">
            <span>{{ 'navbar.portal' | translate }}</span>
          </button>
        </li>
        <li class="nav-item">
          <button
            type="button"
            class="nav-link dir-menu-govco"
            (click)="navegar('observatorio-de-justicia'); closeMenu()"
            [attr.aria-label]="'navbar.observatorio' | translate">
            <span>{{ 'navbar.observatorio' | translate }}</span>
          </button>
        </li>
        <li class="nav-item">
          <button
            type="button"
            class="nav-link dir-menu-govco"
            (click)="navegar('preguntas-frecuentes'); closeMenu()"
            [attr.aria-label]="'navbar.preguntas' | translate">
            <span>{{ 'navbar.preguntas' | translate }}</span>
          </button>
        </li>
        <li class="nav-item">
          <button
            type="button"
            class="nav-link dir-menu-govco"
            (click)="navegar('#'); closeMenu()"
            [attr.aria-label]="'navbar.soporte' | translate">
            <span>{{ 'navbar.soporte' | translate }}</span>
          </button>
        </li>
      </ul>
      <div class="container-search-menu d-md-none">
        <!-- Buscador -->
        <div class="d-flex flex-column justify-content-center">
          <div class="govco-search-basic">
            <div class="container-govco d-flex" id="containter-default2">
              <input
                type="text"
                class="input-search-basic-govco"
                id="input-basic2"
                placeholder="Buscar por componente"
                aria-label="buscar por componente" />
              <button
                class="btn-clean-basic-govco me-2"
                type="button"
                id="btn-clean-basic2"
                aria-label="Limpiar">
                <span class="govco-svg govco-times"></span>
              </button>
              <div class="line-basic-govco"></div>
              <button class="btn-search-basic-govco" type="button"
                aria-label="Buscar">
                <span class="govco-svg govco-search" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
        <!-- Buscador -->
      </div>
    </div>
  </div>
</nav>
<!-- Menu -->
